import { ModelView } from "../model.view";
import {
  DefaultSourceBalanceStoreModel,
  SourceBalanceModelVersion,
  SourceBalanceStoreModel,
} from "../../store/source-balance.store.model";

export class SourceBalancesView extends ModelView<SourceBalanceStoreModel> {
  protected version: SourceBalanceModelVersion;

  accountId: string;
  /** When this balance snapshot applies (from `bDt`). */
  balanceSnapshotAt: string;
  raw: string;

  constructor(model?: SourceBalanceStoreModel) {
    super(model);

    if (typeof model === "object" && model) {
      this.accountId = model.acId;
      this.balanceSnapshotAt = model.bDt;
      this.raw = model.rw ?? "";
      this.version = model.v;
    } else {
      this.version = DefaultSourceBalanceStoreModel.v;
      this.accountId = "";
      this.balanceSnapshotAt = "";
      this.raw = "";
    }
  }

  toStoreModel(): SourceBalanceStoreModel {
    return {
      acId: this.accountId,
      bDt: this.balanceSnapshotAt,
      rw: this.raw,
      v: this.version,
      dc: this.dateCreated.toISOString(),
      dm: this.dateModified.toISOString(),
      id: this.id,
      vid: this.vaultId,
    };
  }

  clone(): SourceBalancesView {
    return new SourceBalancesView(this.toStoreModel());
  }
}
